module.exports = __webpack_public_path__ + "media/src/assets/Images/Arrow-Left-9fb095826a708ddb2ec57ebe52579093.svg";